module.exports = __webpack_public_path__ + "img/eye-open.b315ab60.svg";